import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';

/* Strava interest waitlist - free way to gauge demand before we build/pay for the
   integration. One-tap: uses the logged-in user's account, no form needed. */
const StravaInterestCard = () => {
  const [registered, setRegistered] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/interest/strava`);
        setRegistered(!!res.data?.registered);
      } catch (e) {
        /* ignore */
      }
    })();
  }, []);

  const handleClick = async () => {
    if (busy || registered) return;
    setBusy(true);
    try {
      await axios.post(`${API}/interest/strava`);
      setRegistered(true);
    } catch (e) {
      /* ignore */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm p-6 mb-4" data-testid="strava-interest-card">
      <h3 className="text-lg font-semibold text-gray-900 mb-1 flex items-center gap-2">
        <span className="text-xl">🏃</span> Strava Sync
        <span className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">Coming soon</span>
      </h3>
      <p className="text-gray-500 text-sm mb-4">
        Auto-import your runs, rides and workouts from Strava. We&apos;re gauging interest before we build it
        — tap below if you&apos;d use it and we&apos;ll let you know when it&apos;s ready.
      </p>

      {registered ? (
        <p className="text-sm text-emerald-600 font-medium flex items-center gap-2" data-testid="strava-interest-confirmed">
          <span>✅</span> You&apos;re on the list — we&apos;ll email you when Strava sync launches.
        </p>
      ) : (
        <button
          data-testid="strava-interest-button"
          onClick={handleClick}
          disabled={busy}
          className="w-full py-3 bg-[#FC4C02] hover:bg-[#e34402] text-white font-semibold rounded-xl transition flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <span>👋</span> I&apos;d use Strava sync
        </button>
      )}
    </div>
  );
};

export default StravaInterestCard;
